import { create } from "zustand";
import { persist } from "zustand/middleware";

type AdministrationState = {
  expandedZoneIds: string[] | null;
  setExpandedZoneIds: (zoneIds: string[]) => void;
  selectedZoneId: string | null;
  setSelectedZoneId: (zoneId: string) => void;
};

export const useAdministrationStore = create<AdministrationState>()(
  persist(
    (set) => ({
      expandedZoneIds: null,
      selectedZoneId: null,

      setSelectedZoneId: (selectedZoneId) =>
        set((state) => ({ ...state, selectedZoneId })),
      setExpandedZoneIds: (expandedZoneIds) =>
        set((state) => ({ ...state, expandedZoneIds })),
    }),
    {
      name: "administration-store",
      version: 1,
    },
  ),
);
